export const appHead = {"link":[{"rel":"icon","href":"/favicon.svg","sizes":"any","type":"image/svg+xml"},{"rel":"mask-icon","href":"/icons/safari-pinned-tab.svg","color":"#387248","media":"(prefers-color-scheme: light)"},{"rel":"mask-icon","href":"/icons/safari-pinned-tab-dark.svg","color":"#387248","media":"(prefers-color-scheme: dark)"},{"rel":"preconnect","href":"https://static.northland-co.com","crossorigin":""},{"rel":"dns-prefetch","href":"https://static.northland-co.com"},{"rel":"preconnect","href":"https://api.northland-co.com","crossorigin":""},{"rel":"dns-prefetch","href":"https://api.northland-co.com"},{"rel":"preload","href":"/fonts/Peyda/WebFonts/fonts/woff2/PeydaWeb-Regular.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/Peyda/WebFonts/fonts/woff2/PeydaWeb-Bold.woff2","as":"font","type":"font/woff2","crossorigin":""}],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"msapplication-TileImage","content":"/icons/mstile-150x150.png"},{"name":"msapplication-TileColor","content":"#387248"},{"name":"theme-color","content":"#387248"},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const componentIslandsActive = true

export const payloadExtraction = true

export const prefetchPreloadTags = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true

export const clientNodePlaceholder = false

export const tracingChannelNuxt = false

export const runtimeCompiler = false

export const hasPluginDependencies = true

export const hasParallelPlugins = true

export const hasPluginHooks = true

export const hasIslandOptOutPlugins = true